(() => {
  const AREAS = { EX: 'Exeter', PL: 'Plymouth', TQ: 'Torquay', TR: 'Truro', TA: 'Taunton', BA: 'Bath', DT: 'Dorchester', BH: 'Bournemouth', BS: 'Bristol' };
  const areaOf = (value) => {
    const m = value.toUpperCase().replace(/\s+/g, '').match(/^([A-Z]{1,2})(\d)?/);
    if (!m) return '';
    return m[2] || m[1].length === 2 ? m[1] : '';
  };
  console.assert(areaOf('ex8 4np') === 'EX' && areaOf('B1 1AA') === 'B' && areaOf('E') === '' && areaOf('TQ') === 'TQ' && areaOf('12') === '', 'Postcode area parser');

  document.querySelectorAll('[data-hm-patch]').forEach((patch) => {
    const input = patch.closest('.hm-hero__lead')?.querySelector('[data-sr-postcode]');
    const say = patch.querySelector('[data-hm-patch-say]');
    if (!input || !say) return;
    const idle = say.textContent;
    const codes = patch.querySelectorAll('[data-hm-code]');
    input.addEventListener('input', () => {
      const area = areaOf(input.value);
      const known = AREAS[area];
      codes.forEach((c) => c.classList.toggle('is-lit', c.dataset.hmCode === area));
      patch.classList.toggle('is-out', Boolean(area) && !known);
      say.textContent = !area ? idle
        : known ? `${area} is the ${known} postcode area. We fit there.`
        : `${area} is outside the nine areas we cover, but you can still ask.`;
    });
  });
})();

(() => {
  const video = document.querySelector('[data-hm-video]');
  const hero = video?.closest('.hm-hero');
  const button = hero?.querySelector('[data-hm-video-toggle]');
  if (!video || !button) return;
  const KEY = 'hm-hero-video-paused';
  const wide = matchMedia('(min-width: 48em)');
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = sessionStorage.getItem(KEY) === '1'; } catch {}
  let loaded = false;
  let inView = false;

  const allowed = () => wide.matches && !still.matches && navigator.connection?.saveData !== true;
  const label = () => {
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
  };
  const play = () => {
    if (!loaded) {
      loaded = true;
      // Poster lives in a data attribute: browsers fetch a poster even on a display:none video, so phones would pay for it.
      if (video.dataset.poster) video.poster = video.dataset.poster;
      JSON.parse(video.dataset.sources || '[]').forEach(({ src, type }) => {
        const source = document.createElement('source');
        source.src = src;
        source.type = type;
        video.append(source);
      });
      video.load();
    }
    video.play().then(() => {
      if (!allowed()) return update();
      video.classList.add('is-playing');
      button.hidden = false;
    }).catch(() => {});
  };
  const update = () => {
    if (!allowed()) {
      video.pause();
      video.classList.remove('is-playing');
      button.hidden = true;
      return;
    }
    // A pause carried over from an earlier page still shows the button so the visitor can resume.
    if (paused) { video.pause(); button.hidden = false; return; }
    if (inView && !document.hidden) play();
    else video.pause();
  };

  button.addEventListener('click', () => {
    paused = !paused;
    try { sessionStorage.setItem(KEY, paused ? '1' : '0'); } catch {}
    label();
    update();
  });
  new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; update(); }).observe(hero);
  document.addEventListener('visibilitychange', update);
  wide.addEventListener('change', update);
  still.addEventListener('change', update);
  label();
})();
